import { cr } from "fire-wind-water";
import { Parsing } from "../mvc/parsing";
import {
  SkIf,
  SkText,
  SkClass,
  SkStyle,
  SkProp,
  SkEvent,
  SkHtml,
} from "../mvc";

/*
 * sk-text="$data.isShow"
 * sk-text="$data.show.isLoading"
 * */

class BoundView {
  static attrs: unknown = {
    "sk-if": SkIf,
    "sk-text": SkText,
    "sk-html": SkHtml,
    "sk-class": SkClass,
    "sk-style": SkStyle,
    "sk-prop": SkProp,
    "sk-event": SkEvent,
  };

  constructor(private selector: string, private module: any) {
    if (selector) {
      this.viewDoms(document.querySelectorAll(selector));
    }
  }

  viewDoms(nodes: NodeListOf<HTMLElement>): void {
    cr.each(nodes, (d) => {
      cr.each(d.attributes, (o) => {
        if (
          ["sk-if", "sk-text", "sk-html", "sk-class", "sk-style"].indexOf(
            o.name
          ) !== -1
        ) {
          this.skProp(d, o.name, o.value);
        }
        if (/sk-prop\./.test(o.name)) {
          this.skProperty(o.name.replace("sk-prop.", ""), o.value, d);
        }
        if (/sk-event\./.test(o.name)) {
          this.skEvent(o.name.replace("sk-event.", ""), o.value, d);
        }
      });
      if (d.children) {
        this.viewDoms(d.children);
      }
    });
  }

  skProp(d: HTMLElement, name: string, value: string): void {
    const dr = Parsing.attr(value);
    cr.each(dr, (m) => {
      if (!this.module.$$directive[m]) {
        this.module.$$directive[m] = [];
      }
      this.module.$$directive[m].push(
        new BoundView.attrs[name](d, value, this.module)
      );
    });
  }

  skProperty(key: string, value: string, elem: HTMLElement): void {
    const dr = Parsing.attr(value);
    cr.each(dr, (m) => {
      if (!this.module.$$directive[m]) {
        this.module.$$directive[m] = [];
      }
      this.module.$$directive[m].push(
        new BoundView.attrs["sk-prop"](elem, key, value, this.module)
      );
    });
  }

  skEvent(key: string, value: string, elem: HTMLElement): void {
    new BoundView.attrs["sk-event"](elem, key, value, this.module);
  }
}

export { BoundView };
